import React from "react";
import { useTranslation } from "react-i18next";

import { IosDevice } from "./IosDevice";
import { ProsegAppScreen } from "./ProsegAppScreen";
import "./proseg.css";

/**
 * Celular estático com o app PROSEG PAY — substitui as artes de outras marcas
 * nas páginas internas (Team / Gallery). Decorativo (aria-hidden).
 */
export const ProsegPhone = ({ className = "" }) => {
  const { t } = useTranslation("prosegLanding");
  return (
    <div className={`pp-phone-static ${className}`.trim()} aria-hidden="true">
      <div className="pp-phone-scale">
        <IosDevice>
          <ProsegAppScreen t={t} />
        </IosDevice>
      </div>
    </div>
  );
};
